import { observer } from 'mobx-react'
import rootStore from '../../../store/RootStore'
import { MenuSection } from './MenuSection'
import React from 'react'
import { Box, Center, Flex, Spinner, Text } from '@chakra-ui/react'

// Loading spinner for menu sections
const MenuSectionSpinner = () => {
  return (
    <Flex
      width="100%"
      height="calc(100vh - 250px)"
      alignItems="center"
      justifyContent="center">
      <Center flexDirection="column">
        <Spinner
          size="md"
          thickness="3px"
          speed="0.8s"
          color="white"
          mb={3}
        />
        <Text
          color="white"
          fontSize="sm">
          Loading menu...
        </Text>
      </Center>
    </Flex>
  )
}

const MenuSectionContainer = observer(() => {
  const {
    reportStore: { reportOrdered, loadingReport },
  } = rootStore

  // Show spinner while loading or if no data yet
  if (loadingReport || !reportOrdered || reportOrdered.length === 0) {
    return <MenuSectionSpinner />
  }

  return reportOrdered.map((section, sectionIdx) => (
    <MenuSection
      key={sectionIdx}
      id={section.id}
      items={[...section.children]}
      defaultIndex={0}
      title={section.name}
      type={section.type}
      header={true}
      indent={0}
      lastItem={sectionIdx === reportOrdered?.length - 1}
    />
  ))
})

export default MenuSectionContainer
